import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=9a2260e0&scoped=true"
import script from "./DoctorList.vue?vue&type=script&lang=js"
export * from "./DoctorList.vue?vue&type=script&lang=js"
import style0 from "./DoctorList.vue?vue&type=style&index=0&id=9a2260e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2260e0",
  null
  
)

export default component.exports